import {
  createLprGroupAsync,
  deleteLprGroupAsync,
  getAllLprGroupByLicenseAsync,
  getLprGroupByIdAsync,
  updateLprGroupAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateLprGroupAsync = () => useMutation(createLprGroupAsync);

export const useGetLprGroupByIdAsync = () => useMutation(getLprGroupByIdAsync);

export const useGetAllLprGroupByLicenseAsync = () =>
  useMutation(getAllLprGroupByLicenseAsync);

export const useUpdateLprGroupAsync = () => useMutation(updateLprGroupAsync);

export const useDeleteLprGroupAsync = () => useMutation(deleteLprGroupAsync);
